<!-- cdkScrollable: registers the container with the CDK's scroll dispatcher, so menus and tooltips
opened from a cell follow their trigger instead of hanging in place once this is what scrolls. -->
<div class="table-scroll-container" cdkScrollable #tableScroll [style.max-height]="maxHeight">
  <table
    [ngClass]="[rowType, 'cell-borders-' + cellBorders]"
    [style.--lib-generic-table-cell-padding-x]="cellPaddingX"
    [style.--lib-generic-table-min-width]="minTableWidth"
  >
    <thead>
      <ng-container *ngTemplateOutlet="headers || defaultHeaderTemplate; context: { $implicit: data }"></ng-container>
    </thead>
    <tbody [ngClass]="{ 'with-action': withAction }">
      <ng-container *ngTemplateOutlet="rows || defaultRowTemplate; context: { $implicit: rows }"></ng-container>
    </tbody>
  </table>
  <!-- Inside the scroll container, so it still marks the end of the list once the container is what
  scrolls rather than the page. -->
  <div #endOfList></div>
</div>

<ng-template #defaultHeaderTemplate let-data>
  @for (header of data[0] | keyvalue; track header) {
    <th>{{ header.key }}</th>
  }
</ng-template>
<ng-template #defaultRowTemplate let-row>
  @for (row of row | keyvalue; track row) {
    <td>{{ row.value }}</td>
  }
</ng-template>
